import React from "react";
import { navigate } from "../../services";
import {
    ButtonActionGroup,
    Button,
    BTN_SMALL,
    TYPE_SECONDARY,
    TYPE_SUCCESS,
    TYPE_FAILURE,
} from "../../lib";

type Props = {
    decided: boolean;
    onAccept: () => void;
    onReject: () => void;
};

export default class Actions extends React.Component<Props> {
    onAccept = () => this.props.onAccept();
    onReject = () => this.props.onReject();

    onReturnClick = () => navigate.back();

    render() {
        const { decided } = this.props;
        return (
            <ButtonActionGroup margin="60px 0 0 0">
                {!decided && (
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_SUCCESS}
                        messageId="merge.confirmMerge"
                        onClick={this.onAccept}
                    />
                )}

                {!decided && (
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_FAILURE}
                        messageId="merge.cancelMerge"
                        onClick={this.onReject}
                    />
                )}

                <Button
                    size={BTN_SMALL}
                    type={TYPE_SECONDARY}
                    messageId="form.return"
                    onClick={this.onReturnClick}
                />
            </ButtonActionGroup>
        );
    }
}
